import React, { Fragment, useEffect, useRef, useState } from "react";
import { Select, Input, TextArea, Button, Slider, CountryDropdown, Toast } from "@kaleyra/emmy";
import { useTranslation } from "react-i18next";
import cn from 'classnames';
import Styles from './index.module.scss';
import Plus from '../../../../../../assets/Plus';
import { ReactComponent as Trash } from '../../../../../../assets/delete_icon.svg';
import { ICountry, ICountryList, WhatsappTemplateFieldNameType, WhatsappTemplateResponseType } from "../../../../../../interface/whatsapTemplate";
import { isEmpty } from "lodash";
import { WhatsappTemplateType } from "../../../../../../store/models/whatsappTemplate.interface";

export type DispatchPropsType = {
    onChange: (fields: { name: WhatsappTemplateFieldNameType; value: string }) => void;
    onClose: () => void;
    onLoad: () => void;
    loadTemplate: (id: string) => void;
    loadTemplateList: () => void;
    fetchCountryList: () => void;
    onSave: (reqObj: any, callback: (resp: any, flag: boolean) => void) => void;
    onLoadData: () => void;
    setTemplateState: (tempObj: Partial<Record<WhatsappTemplateFieldNameType, (string)>>) => void;

};

export type MapStatePropsType = {
    templateLayout: any;
    countryList: any[];
    template: Record<WhatsappTemplateFieldNameType, (string | number | undefined)>;
    templateViewObj: WhatsappTemplateType;
    data: any;
    params: Record<string, any> | undefined;
};

export interface IOption {
    label: string;
    value: string;
}

const EditTemplateForm: React.FC<MapStatePropsType & DispatchPropsType> = ({
    templateLayout,
    template,
    templateViewObj,
    data,
    params,
    countryList,
    onClose,
    fetchCountryList,
    loadTemplate,
    loadTemplateList,
    onSave,
    onChange,
    onLoad,
    setTemplateState,
}) => {
    console.log(template, 'template')

    const [countries, setCountries] = useState<ICountry[]>([]);
    var [buttonOptionElements, setButtonOptionElements] = useState<Function[]>([]);
    var [canAddbtnOptnElements, setcanAddbtnOptnElements] = useState<boolean>(false);

    var [numberText, setNumberText] = useState<string | undefined>(template?.call_button_number?.toString());

    const numberSetStateRef = useRef(setNumberText)
    const numberStateRef = useRef(numberText)
    const call_button_number = template?.call_button_number

    useEffect(() => {
        numberStateRef.current = numberText
    }, [numberText, call_button_number])

    useEffect(() => {
        setEditObj()
    }, [templateViewObj?.id])

    useEffect(() => {
        if (template?.button_type) {
            setButtonOptions(template?.button_type?.toString())
        }
    }, [template.button_type])

    const { t } = useTranslation();

    const setEditObj = () => {

        if (templateViewObj?.translation) templateViewObj.translation = [Object.values(templateViewObj.translation)[0]];
        const { translation, template_category_details } = templateViewObj;
        setTemplateState({
            "id": templateViewObj?.id,
            "name": templateViewObj?.name,
            "template_category_id": template_category_details?.id,
            "body": translation?.[0]?.body,
            "language": translation?.[0]?.language,
            "header_content": translation?.[0]?.header_content,
            "header_content_type": translation?.[0]?.header_content_type,
            "header_content_total_params": translation?.[0]?.header_content_total_params,
            "footer_content": translation?.[0]?.footer_content,
            "button_type": translation?.[0]?.button_type,
            "quick_reply_button1": translation?.[0]?.quick_reply_button1,
            "quick_reply_button2": translation?.[0]?.quick_reply_button2,
            "quick_reply_button3": translation?.[0]?.quick_reply_button3,
            "second_button_type": translation?.[0]?.second_button_type,
            "website_url_type": translation?.[0]?.website_url_type,
            "website_button_text": translation?.[0]?.website_button_text,
            "website_url": translation?.[0]?.website_url,
            "call_button_text": translation?.[0]?.call_button_text,
            "call_button_number": translation?.[0]?.call_button_number
        }
        )
    }

    const BUTTON_TYPE_OPTIONS: Record<string, string> = {
        '1': t('BLD01575'),
        '2': t('BLD01576'),
        '3': t('chatbotUrl')
    }
    const HEADER_TYPE_OPTIONS: Record<string, string> = {
        '0': t('BLD01577'),
        '1': t('Text'),
        '2': t('BLD01579')
    }
    const WEBSITE_URL_OPTIONS: Record<string, string> = {
        '1': t('BLD01580'),
        '2': t('BLD01581')
    }

    const quickReplyKeyType: WhatsappTemplateFieldNameType[] = [
        "quick_reply_button1",
        "quick_reply_button2",
        "quick_reply_button3",
    ]

    const urlKeyType: WhatsappTemplateFieldNameType[] = [
        "website_url_type",
        "website_button_text",
        "website_url",
    ]

    const numberKeyType: WhatsappTemplateFieldNameType[] = [
        "call_button_text",
        "call_button_number"
    ]

    useEffect(() => {
        onLoad();
        loadTemplate(params?.id);
        fetchCountryList();
    }, [])

    useEffect(() => {
        if (Array.isArray(countryList)) {
            let country = countryList.map((item: ICountryList) => ({
                "countryid": item.country_id,
                "name": item.name,
                "code": item.code,
                "isoCode": item.iso_code
            }))
            setCountries([...country])
        }
    }, [countryList])



    const getLabels = (key: string): Record<string, any> => {
        switch (key) {
            case "buttonType":
                return { ...BUTTON_TYPE_OPTIONS };
            case "headerType":
                return { ...HEADER_TYPE_OPTIONS };
            case "websiteUrlType":
                return { ...WEBSITE_URL_OPTIONS };
            case "category":
                return { ...templateLayout?.categories };
            case "language":
                return { ...templateLayout?.languages };
            default:
                return {};
        }
    }

    const getOptions = (key: string): IOption[] => {
        let options: IOption[] = [];
        let keyOptions: Record<string, any> = { ...getLabels(key) };
        Object.keys(keyOptions).forEach((key: string) => {
            if (key)
                options.push({
                    label: keyOptions[key],
                    value: key
                });
        })
        return options;
    }

    const onLocalChange = (
        name: WhatsappTemplateFieldNameType,
        isCustom: boolean = false
    ) => (value: any) => {
        if (name === 'button_type' && value !== template.button_type) {
            setButtonOptions(value)
            if (value === '0') {
                setcanAddbtnOptnElements(false)
                removeOptionKeys(true);
            }
            else {
                setcanAddbtnOptnElements(true)
            }
        }
        onChange({
            name,
            value: isCustom
                ? (value as React.ChangeEvent<
                    HTMLInputElement | HTMLTextAreaElement
                >).target.value
                : value,
        });
    };

    const onNumberChange = (
        name: WhatsappTemplateFieldNameType,
        isCustom: boolean = false
    ) => (value: any, code: string) => {
        let numberValue = isCustom ? (value as React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>).target.value : value
        numberSetStateRef.current(numberValue)
        if (code !== template.country_code) {
            let countryDetails = countries.find((item: ICountry) => item.code === code);
            if (countryDetails) {
                onChange({ name: 'country_code', value: countryDetails.isoCode })
                onChange({ name: 'country_dialcode', value: countryDetails.code })
            }
        }
        onChange({
            name,
            value: isCustom
                ? (value as React.ChangeEvent<
                    HTMLInputElement | HTMLTextAreaElement
                >).target.value
                : value,
        });
    };

    const phoneNumberElement = () => {

        return (
            <div>
                <Input
                    placeholder={t("BLD01582")}
                    label={t("BLD01582")}
                    onChange={onLocalChange('call_button_text', true)}
                    value={template?.call_button_text}
                    showBottomLabelSpace={false}
                    className={Styles.formField}
                />
                <CountryDropdown
                    data={countries}
                    mode="iso"
                    label={t('mainMobileNumber')}
                    placeholder={t('mainMobileNumber')}
                    onChange={onNumberChange('call_button_number', true)}
                    defaultSelectValue={template?.country_dialcode ? template?.country_dialcode?.toString() : "91"}
                    value={numberStateRef.current}
                />
            </div>
        );
    }

    const urlElement = (): React.ReactNode => {
        return <>
            <Select
                label={t('BLD01583')}
                placeholder={t('BLD01583')}
                options={getOptions('websiteUrlType')}
                onChange={onLocalChange('website_url_type')}
                value={template?.website_url_type ? template?.website_url_type : undefined}
                showBottomLabelSpace={false}
                className={Styles.formField}
            />
            <Input
                placeholder={t("BLD01582")}
                label={t("BLD01582")}
                onChange={onLocalChange('website_button_text', true)}
                value={template?.website_button_text}
                showBottomLabelSpace={false}
                className={Styles.formField}
            />
            <Input
                placeholder={t("BLD01584")}
                label={t("BLD01584")}
                onChange={onLocalChange('website_url', true)}
                value={template?.website_url}
                showBottomLabelSpace={false}
                className={Styles.formField}
            />
        </>
    }

    const quickReplyElement = (): React.ReactNode => {
        let key: WhatsappTemplateFieldNameType = quickReplyKeyType[buttonOptionElements.length];
        return <>
            <Input
                placeholder={t("BLD01585")}
                label={t("BLD01585")}
                onChange={onLocalChange(key, true)}
                value={template?.[key]}
                showBottomLabelSpace={false}
                className={Styles.formField}
            />
        </>
    }

    const onClickAddButton = () => {
        if (buttonOptionElements.length < 2 && template.button_type === '1') { setcanAddbtnOptnElements(true) }
        else if (buttonOptionElements.length < 1 && template.button_type !== '1') { setcanAddbtnOptnElements(true) }
        else { setcanAddbtnOptnElements(false); }
        let element: Function = () => { };
        switch (template?.button_type) {
            case "1":
                if (buttonOptionElements.length < 3) element = quickReplyElement;
                break;
            case "2":
                if (buttonOptionElements.length < 2) element = urlElement;
                break;
            case "3":
                if (buttonOptionElements.length < 2) element = phoneNumberElement;
                break;
            default:
                break;
        }
        setButtonOptionElements([...buttonOptionElements, element])
    }

    const setButtonOptions = (buttonType: string) => {
        let element: Function = () => { }
        switch (buttonType) {
            case "1":
                element = quickReplyElement
                break;
            case "2":
                element = phoneNumberElement
                break;
            case "3":
                element = urlElement;
                break;
            default:
                break;
        }
        setButtonOptionElements([element])
    }

    const removeOptionElement = () => {
        if (buttonOptionElements.length > 0) { setcanAddbtnOptnElements(true) }
        else { setcanAddbtnOptnElements(false); }
        setButtonOptionElements([...buttonOptionElements.slice(0, -1)])
        removeOptionKeys();
    }

    const removeOptionKeys = (all?: boolean) => {
        let temp: any = { ...template };
        let optionKeys: any = [];
        if (all) {
            optionKeys = [...quickReplyKeyType, ...urlKeyType, ...numberKeyType]
        }
        else {
            switch (template.button_type) {
                case "1":
                    optionKeys = [`quick_reply_button${buttonOptionElements.length}`]
                    break;
                case "2":
                    optionKeys = urlKeyType
                    break;
                case "3":
                    optionKeys = numberKeyType
                    break;
                default:
                    break;
            }
        }
        optionKeys.forEach((item: string) => {
            delete temp[item];
        })
        setTemplateState(temp);
    }

    const onClickAddVariable = () => {
        var curPos = (document.getElementById("body") as HTMLFormElement).selectionStart;
        let bodyText: string = (document.getElementById("body") as HTMLFormElement).value;
        let variableArray: any[] = Array.from(bodyText?.matchAll(/\{\{\$(.)\}\}/g), x => x[1]);
        let n_elements_sum = Math.floor(variableArray.length * (variableArray.length + 1) / 2);
        let sum = 0;
        variableArray.forEach(x => sum += parseInt(x));
        let num = n_elements_sum - sum;
        let textToInsert = bodyText.slice(0, curPos) + `{{$${num}}}` + bodyText.slice(curPos);
        onChange({
            name: 'body',
            value: textToInsert
        })

    }

    const callback = (res: WhatsappTemplateResponseType, flag: boolean): void => {
        if (flag && res.data && isEmpty(res.error)) {
            Toast(res.message, 'success')
            onClose();
            loadTemplateList();
        } else if (!isEmpty(res.error)) {
            if (res.error.error) {
                if (typeof res.error.error === 'string') {
                    Toast(res.error.error, 'error');
                }
                else {
                    Object.keys(res.error.error).forEach((key: any) => {
                        Toast(res.error[key], 'error');
                    });
                }
            }
            else if (res.error.message) {
                Toast(res.error.message, 'error');
            }
        } else {
            Toast(res.message, 'error');
        }
    }

    const getRequestObj = () => {
        return ({
            "id": template?.id || "",
            "name": template?.name || "",
            "template_category": template?.template_category_id || "",
            "body": template?.body || "",
            "language": template?.language || "",
            "header_content": template?.header_content || "",
            "header_content_type": template?.header_content_type || "",
            "header_content_total_params": template?.header_content_total_params || "",
            "footer_content": template?.footer_content || "",
            "button_type": template?.button_type || "",
            "quick_reply_button1": template?.quick_reply_button1 || "",
            "quick_reply_button2": template?.quick_reply_button2 || "",
            "quick_reply_button3": template?.quick_reply_button3 || "",
            "second_button_type": template?.second_button_type || "",
            "website_url_type": template?.website_url_type || "",
            "website_button_text": template?.website_button_text || "",
            "website_url": template?.website_url || "",
            "call_button_text": template?.call_button_text || "",
            "call_button_number": template?.call_button_number || "",
        }
        )
    }

    const validateFields = () => {

        if (!template.name) {
            Toast(t("BLD01573"), "error");
            return false;
        }
        return true
    }


    const onClickSave = () => {
        let reqObj: Record<string, any> = {}
        reqObj = getRequestObj();
        if (!validateFields()) return;
        onSave(reqObj, callback)

    }

    const getBody = () => {
        return <Fragment>
            <div className={Styles.container}>
                <p className={Styles.message}> {t('BLD01587')}</p>
                <Input
                    placeholder={t("mainTitle")}
                    label={t("mainTitle")}
                    onChange={onLocalChange('name', true)}
                    value={template?.name}
                    showBottomLabelSpace={false}
                    className={Styles.formField}
                />
                <Select
                    label={t("mainLanguage")}
                    placeholder={t("mainLanguage")}
                    options={getOptions('language')}
                    onChange={onLocalChange('language')}
                    value={template?.language}
                    showBottomLabelSpace={false}
                    className={Styles.formField}

                />
                <Select
                    label={t("mainCategory")}
                    placeholder={t("mainCategory")}
                    options={getOptions('category')}
                    onChange={onLocalChange('template_category_id')}
                    value={template?.template_category_id}
                    showBottomLabelSpace={false}
                    className={Styles.formField}

                />
                <p className={Styles.subheading}>{t('templateHeader')}</p>
                <div>
                    <Select
                        label={t("headerType")}
                        placeholder={t("headerType")}
                        options={getOptions('headerType')}
                        onChange={onLocalChange('header_content_type')}
                        value={template?.header_content_type}
                        showBottomLabelSpace={false}
                        className={Styles.formField}
                    />
                    {template?.header_content_type === "1" && <Input
                        placeholder={t("headerText")}
                        label={t("headerText")}
                        onChange={onLocalChange('header_content', true)}
                        value={template?.header_content}
                        showBottomLabelSpace={false}
                        className={Styles.formField}
                    />

                    }

                </div>
                <div className={Styles.spaceBetween}>
                    <p className={cn(Styles.subheading, Styles.noMargin, Styles.noPadding)}>{t('body')}</p>
                    <Button
                        type="tertiary"
                        icon={<Plus color="#1676EE" width={18} height={18} />}
                        iconPosition="left"
                        className={Styles.addVariable}
                        onClick={onClickAddVariable}
                    >
                        <span>{t('BLD00427')}</span>
                    </Button>
                </div>
                <div>
                    <TextArea
                        // css
                        placeholder={t('mainTemplateBody')}
                        label={t('mainTemplateBody')}
                        onChange={onLocalChange('body', true)}
                        rows={7}
                        value={template?.body}
                        id={'body'}
                        characterLimit={1024}
                        showBottomLabelSpace={false}
                        className={Styles.formField}
                    />
                </div>
                <p className={Styles.subheading}>{t('templateFooter')}</p>
                <div>
                    <Input
                        placeholder={t("BLD01586")}
                        label={t("BLD01586")}
                        onChange={onLocalChange('footer_content', true)}
                        value={template?.footer_content}
                        showBottomLabelSpace={false}
                        className={Styles.formField}
                    />
                </div>
                <p className={cn(Styles.subheading, Styles.noMargin)}>{t('templateButton')}</p>
                <p className={Styles.subheadingText}>{t('BLD01624')}</p>
                <div>
                    <Select
                        label={t("buttonType")}
                        placeholder={t("buttonType")}
                        options={getOptions('buttonType')}
                        onChange={onLocalChange('button_type')}
                        value={template?.button_type}
                        showBottomLabelSpace={false}
                        className={Styles.formField}
                    />
                </div>
                {!isEmpty(buttonOptionElements) && buttonOptionElements.map((item, index) => {
                    return (<>
                        <div className={Styles.spaceBetween}>
                            <p className={cn(Styles.message, Styles.noMargin)}>{t('BLD01572')} {index + 1}</p>
                            {index > 0 && index + 1 === buttonOptionElements.length && <Button
                                type="link"
                                icon={<Trash
                                    fill="#1676EE"
                                    width={18} height={18}
                                    onClick={() => removeOptionElement()}
                                />}
                                iconPosition="left"
                                small
                                className={Styles.addVariable}
                            />}
                        </div>
                        {item()}
                    </>)
                })}
                {canAddbtnOptnElements && <Button
                    type="tertiary"
                    icon={<Plus color="#1676EE" width={18} height={18} />}
                    iconPosition="left"
                    className={Styles.addVariable}
                    onClick={onClickAddButton}
                    small
                >
                    <span>{t('BLD01571')}</span>
                </Button>}
            </div>
        </Fragment >
    };

    const getFooter = (): React.ReactNode => {
        return (
            <div className={Styles.flexEnd}>
                <Button type="tertiary" onClick={onClose}>
                    {t('mainCancel')}
                </Button>
                <Button type="primary" onClick={onClickSave}>
                    {t('mainSave')}
                </Button>
            </div>
        );
    };

    return (
        <Slider
            containerId="root-modal"
            onClose={onClose}
            visibility={true}
            footer={getFooter()}
            title={t('KLR00108')}
        >
            <div className={Styles.container}>{getBody()}</div>
        </Slider>
    );


}

export default EditTemplateForm;